import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { registration } from './registration';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  
  constructor(private http: HttpClient) { }

  formData(data:registration): Observable<any> {
    return this.http.post<registration>('https://digimiles.net/apis/landing_query.php', data, this.httpOptions);
  }
}
